import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/UniversityGame/scenes/GameIntro';

// Note: RouteComponentProps<{}> MUST be removed if sub-component OR MUST return 'withRouter(PhaserDemo)'
interface PhaserUniversityGameProps {
    onComplete: () => void;

}

interface PhaserUniversityGameState {
}

const phaserConfig: GameConfig = {
    title: "Planet I: Grade 4 University Game", // This needs to be changed
    version: "1.1", // Required
    physics: { // Physics can be added here
        default: 'arcade',
        arcade: {
            debug: false,
            gravity: { y: 0 }
        }
    },
    backgroundColor: "#000000", // Not really needed
    "render.pixelArt": true // 'Anti-Aliasing' when off
};

class PhaserUniversityGame extends React.Component<PhaserUniversityGameProps, PhaserUniversityGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserUniversityGameProps) {
        super(props);
        bindAllOfThis(this, PhaserUniversityGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={phaserConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserUniversityGame;



// WEBPACK FOOTER //
// ./src/games/UniversityGame/Main.tsx